export default __webpack_public_path__ + "static/media/meal-benefit.a14ddeca.png";